<template>
  <l-cache ref="cache" :get-data="getItem" :id="$route.query.id">
    <ControllerDetails slot-scope="{data}" :form-data="data" :controller-type="$route.query.type"></ControllerDetails>
  </l-cache>
</template>
<script>
import ControllerDetails from './controllerDetails'
export default {
  name: 'controllerDetailsBox',
  components: {ControllerDetails},
  methods: {
    async getItem (key) {
      let type = this.$route.query.type
      if (type === 'dir') {
        let {items} = await this.$store.dispatch('park/getDirControllerList', {pagination: {page: 1, rowsPerPage: 10}, filter:[{key:'name',value:this.$route.query.name}],search: {key: 'id', value: this.$route.query.id}})
        return items[0]
      }
      else {
        let {items} = await this.$store.dispatch('park/getUnDirControllerList', {pagination: {page: 1, rowsPerPage: 10}, filter:[{key:'name',value:this.$route.query.name}],search: {key: 'id', value: this.$route.query.id}})
        return items[0]
      }
    }
  }
}
</script>
